/**
 * @generated SignedSource<<03b079da583f15234db6c48e1fc1d246>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type queueTopicHooksHomepageMidPageQueueTopicQuery$data = {
  readonly packageTopQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2StoryPackageTopicQueue">;
  } | null | undefined;
  readonly storyPackageTwoQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2StoryPackageTopicQueue">;
  } | null | undefined;
  readonly " $fragmentType": "queueTopicHooksHomepageMidPageQueueTopicQuery";
};
export type queueTopicHooksHomepageMidPageQueueTopicQuery$key = {
  readonly " $data"?: queueTopicHooksHomepageMidPageQueueTopicQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"queueTopicHooksHomepageMidPageQueueTopicQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "hooksHomeV2StoryPackageTopicQueue"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "packageTopQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "storyPackageTwoQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "queueTopicHooksHomepageMidPageQueueTopicQuery",
  "selections": [
    {
      "alias": "packageTopQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "packageTopQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": "storyPackageTwoQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "storyPackageTwoQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "3b3a84d0c4000f70f7fa968003247fea";

export default node;
